import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  subadmindata: {},
  isFetching: false,
  isSuccess: false,
  isUpdated: false,
  isError: false,
  errorMessage: '',
};

export const fetchSubAdminUser = createAsyncThunk(
  'user/subAdmin/detailed/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.get('/api/user/subAdmin/detailed/' + udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const updateSubadminUser = createAsyncThunk(
  'roles/editrole',
  async (udata, thunkAPI, dispatch) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/user/subAdmin', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const editSubAdminSlice = createSlice({
  name: 'editsubadmin',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateEditsubadmin: (state, { payload }) => {
      state.subadmindata = {};
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [fetchSubAdminUser.fulfilled]: (state, { payload }) => {
      // console.log(payload)
      state.subadmindata = payload.data;
      // state.response = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [fetchSubAdminUser.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchSubAdminUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    // update reducers

    [updateSubadminUser.fulfilled]: (state, { payload }) => {
      // console.log(payload);
      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.isUpdated = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';

      return state;
    },
    [updateSubadminUser.pending]: (state) => {
      state.isFetching = true;
    },
    [updateSubadminUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }



  },
});




export const { clearStateEditsubadmin } = editSubAdminSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateEditsubadmin());
  }
}

// export function clearStateSuccess() {

//   return async (dispatch) => {
//     dispatch(isSuccess());
//   }
// }

export const editSubAdminSelector = (state) => state.editsubadmin;

export default editSubAdminSlice.reducer;
